import { render, staticRenderFns } from "./google-ad-display.vue?vue&type=template&id=c3bdfc8a"
import script from "./google-ad-display.vue?vue&type=script&lang=js"
export * from "./google-ad-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports